export default "__VITE_ASSET__CO056T$q__"